// DO NOT EDIT MANUALLY
// This file was automatically generated by `scripts/MapboxStyles/process.ts`

import { MapboxStyleLayer } from '../types'

export const mapboxStyleGroupLayers_atlas_barriers__line: MapboxStyleLayer[] = [
  {
    minzoom: 7,
    filter: [
      'match',
      ['get', 'highway'],
      ['motorway', 'motorway_link', 'trunk', 'trunk_link'],
      true,
      false,
    ],
    type: 'line',
    id: 'barriers-motorway',
    paint: {
      'line-color': [
        'case',
        ['match', ['get', 'bridge'], ['yes'], true, false],
        '#ef34e5',
        ['match', ['get', 'tunnel'], ['yes'], true, false],
        'rgba(172, 109, 176, 0.59)',
        '#000000',
      ],
      'line-width': ['interpolate', ['linear'], ['zoom'], 10, 2, 18, 4],
      'line-opacity': 0.8,
    },
  },
  {
    id: 'railway-rail',
    type: 'line',
    filter: ['match', ['get', 'railway'], ['rail'], true, false],
    paint: {
      'line-color': 'hsl(300, 88%, 10%)',
      'line-width': ['interpolate', ['linear'], ['zoom'], 10, 2, 18, 4],
    },
  },
  {
    id: 'railway_rail-white',
    type: 'line',
    filter: ['match', ['get', 'railway'], ['rail'], true, false],
    paint: {
      'line-color': 'hsl(300, 4%, 97%)',
      'line-width': ['interpolate', ['linear'], ['zoom'], 10, 1.7, 18, 3],
      'line-dasharray': [1, 1.2],
    },
  },
  {
    id: 'railway_light_rail',
    type: 'line',
    filter: ['match', ['get', 'railway'], ['light_rail'], true, false],
    paint: {
      'line-color': 'hsl(300, 88%, 10%)',
      'line-width': ['interpolate', ['linear'], ['zoom'], 10, 1, 18, 2],
    },
  },
  {
    id: 'railway_light_rail-white',
    type: 'line',
    filter: ['match', ['get', 'railway'], ['light_rail'], true, false],
    paint: {
      'line-color': 'hsl(300, 4%, 97%)',
      'line-width': ['interpolate', ['linear'], ['zoom'], 10, 0.7, 18, 1.5],
      'line-dasharray': [2, 2],
    },
  },
]
